import React, { FC } from 'react';

import { EmailHeadersProps } from '../ContactEventHistoryInterface';

const EmailHeaders: FC<EmailHeadersProps> = (props: EmailHeadersProps): JSX.Element => {
    const { headers } = props;

    return (
        <div className="board" style={{ wordBreak: 'break-word' }}>
            {headers}
        </div>
    );
};

export default EmailHeaders;
